var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ElementRef, QueryList, AfterViewInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UpdateEntryDescription } from '../../../state/actions/commands';
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../../../state/drive-state';
var EntryDescriptionPanelComponent = /** @class */ (function () {
    function EntryDescriptionPanelComponent(store) {
        this.store = store;
        this.editingDescription$ = new BehaviorSubject(false);
        this.savingDescription$ = new BehaviorSubject(false);
    }
    EntryDescriptionPanelComponent.prototype.ngAfterViewInit = function () {
        this.textArea.changes.subscribe(function (queryList) {
            queryList.length && queryList.first.nativeElement.focus();
        });
    };
    EntryDescriptionPanelComponent.prototype.editDescription = function () {
        this.editingDescription$.next(true);
    };
    EntryDescriptionPanelComponent.prototype.updateDescription = function (entry, value) {
        var _this = this;
        this.editingDescription$.next(false);
        if (entry.description === value)
            return;
        this.savingDescription$.next(true);
        this.store.dispatch(new UpdateEntryDescription(entry, value)).subscribe(function () {
            _this.savingDescription$.next(false);
        });
    };
    __decorate([
        Select(DriveState.selectedEntryOrActiveFolder),
        __metadata("design:type", Observable)
    ], EntryDescriptionPanelComponent.prototype, "entry$", void 0);
    return EntryDescriptionPanelComponent;
}());
export { EntryDescriptionPanelComponent };
